import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43e45b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

import { FormInstance } from "element-plus";
import { reactive, ref, watch } from "vue";
import api from "@/request/api";
interface formData {
  title: string;
  content: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  props: {
    dialogVisible: { type: Boolean },
    code: null
  },
  emits: ["closeD"],
  setup(__props: any, { emit }) {

const props = __props as {
  dialogVisible: boolean;
  code: number;
};


let dialogVisible = ref(false);
let id = ref(0);
watch(
  () => props.dialogVisible,
  () => {
    dialogVisible.value = props.dialogVisible;
    id.value = props.code;
    if (dialogVisible.value === true) {
      getDetail();
    }
  },
);
let formData = ref<formData>({
  title: "",
  content: "",
});
const getDetail = () => {
  try {
    api.get(`notice/detail?id=${id.value}`).then((res: any) => {
      formData.value.title = res.data.detail[0].title;
      formData.value.content = res.data.detail[0].content;
    });
  } catch (error) {}
};

const closeD = () => {
  dialogVisible.value = false;
  formData = ref<formData>({
    title: "",
    content: "",
  });
  id.value = 0;
  emit("closeD", dialogVisible);
};
let pc = sessionStorage.getItem("pc");
const dialogWidth = ref("50%");
if (pc === "2") {
  dialogWidth.value = "98%";
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_unref(dialogVisible))
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
        title: _ctx.$t('table.detail'),
        width: dialogWidth.value,
        "show-close": false,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              onClick: closeD,
              style: {"padding":"8px 15px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("offer.close")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              model: _unref(formData),
              "label-width": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('table.Title')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(formData).title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).title) = $event)),
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('table.content')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(formData).content,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).content) = $event)),
                      type: "textarea",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "width"]))
    : _createCommentVNode("", true)
}
}

})